import React, { useEffect, useState, useRef } from "react";
import io from "socket.io-client";
import API from "../utils/api";

const socket = io("https://api-dashboard.nordmann-inkasso.de", { withCredentials: true });

const ChatModal = ({ invoiceId }) => {
  const [message, setMessage] = useState("");
  const [userId, setUserId] = useState("");
  const [messages, setMessages] = useState([]);
  const [role, setRole] = useState("");
  const chatEndRef = useRef(null);

  const scrollToBottom = (behavior = "smooth") => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior });
    }
  };

  useEffect(() => {
    scrollToBottom(); // scroll smoothly when messages change
  }, [messages]);

  useEffect(() => {
    if (invoiceId) scrollToBottom("auto"); // instantly scroll when modal opens
  }, [invoiceId]);

  // ✅ Fetch user info (ID + role)
  useEffect(() => {
    API.get("/auth/me", { withCredentials: true })
      .then((res) => {
        if (res.data?.user?._id) setUserId(res.data.user._id);
        if (res.data?.user?.role) setRole(res.data.user.role);
      })
      .catch((err) => console.error("Error fetching user:", err));
  }, []);

  // ✅ Fetch chat + socket handling
  useEffect(() => {
    if (!invoiceId) return;

    API.get(`get-chat/${invoiceId}`, { withCredentials: true })
      .then((res) => {
        setMessages(res.data || []);
      })
      .catch((err) => console.error("Error loading messages:", err));

    socket.emit("joinRoom", invoiceId);

    socket.on("receiveMessage", (data) => {
      if (data.invoiceId === invoiceId) {
        setMessages((prev) => [...prev, data]);
      }
    });

    return () => socket.off("receiveMessage");
  }, [invoiceId]);

  // ✅ Send message
  const sendMessage = () => {
    if (message.trim()) {
      socket.emit("sendMessage", {
        invoiceId,
        userId,
        message,
        role
      });
      setMessage("");
    }
  };

  // ✅ Styles
  const chatContainerStyle = {
    height: "400px",
    overflowY: "auto",
    backgroundColor: "#e5ddd5",
    padding: "15px",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
  };

  const messageStyle = (isSender) => ({
    alignSelf: isSender ? "flex-end" : "flex-start",
    backgroundColor: isSender ? "#dcf8c6" : "#ffffff",
    color: "#333",
    padding: "10px 14px",
    borderRadius: "18px",
    maxWidth: "70%",
    marginBottom: "10px",
    boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
  });

  const timeStyle = {
    fontSize: "11px",
    color: "#999",
    marginTop: "4px",
    textAlign: "right",
  };

  return (
    <div>
      {/* Chat Area */}
      <div style={chatContainerStyle}>
        {messages.map((msg, idx) => {
          const isSender = msg.userId?._id === userId;
          return (
            <div key={idx} style={messageStyle(isSender)}>
              <div>
                {msg.message}
                <div style={timeStyle}>
                  {new Date(msg.createdAt).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </div>
              </div>
            </div>
          );
        })}
        <div ref={chatEndRef} />
      </div>

      {/* Input Area */}
      <div className="d-flex mt-3 align-items-center">
        <input
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          type="text"
          className="form-control me-2"
          placeholder="Type a message..."
          style={{
            borderRadius: "20px",
            padding: "10px 15px",
            border: "1px solid #ccc",
          }}
        />
        <button
          className="btn btn-success px-4"
          onClick={sendMessage}
          style={{ borderRadius: "20px" }}
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatModal;
